module.exports = __webpack_public_path__ + "img/img.eb7ee22a.png";